import { ReactNode } from 'react';
// Styles
import styles from './WizardStepLayout.module.scss';

type WizardStepLayoutProps = {
  children: ReactNode;
  /** Right-hand column, e.g. the pricing summary. Stacks under the content on mobile. */
  aside?: ReactNode;
};

const WizardStepLayout = ({
  children,
  aside,
}: WizardStepLayoutProps): JSX.Element => (
  <div className={styles.root}>
    <div className={styles.main}>{children}</div>
    {aside && <aside className={styles.aside}>{aside}</aside>}
  </div>
);

export default WizardStepLayout;
